export default __webpack_public_path__ + "static/media/refLayout_2.8bd81c73.png";